import type { AdminAnalytics } from '../types';

type Props = {
  analytics: AdminAnalytics;
};

export default function AdminStats({ analytics }: Props) {
  const safeAnalytics = {
    totalSurgeries: analytics?.totalSurgeries ?? 0,
    totalImplants: analytics?.totalImplants ?? 0,
    failedImplants: analytics?.failedImplants ?? 0,
    failRate: analytics?.failRate ?? 0,
  };

  const stats = [
    {
      label: 'Toplam Ameliyat',
      value: safeAnalytics.totalSurgeries,
      icon: 'ri-surgical-mask-line',
      color: 'bg-teal-100 text-teal-600',
    },
    {
      label: 'Toplam İmplant',
      value: safeAnalytics.totalImplants,
      icon: 'ri-tooth-line',
      color: 'bg-cyan-100 text-cyan-600',
    },
    {
      label: 'Başarılı İmplant',
      value: safeAnalytics.totalImplants - safeAnalytics.failedImplants,
      icon: 'ri-check-double-line',
      color: 'bg-emerald-100 text-emerald-600',
    },
    {
      label: 'Başarısız İmplant',
      value: safeAnalytics.failedImplants,
      icon: 'ri-close-circle-line',
      color: 'bg-red-100 text-red-600',
    },
    {
      label: 'Başarı Oranı',
      value: safeAnalytics.totalImplants > 0
        ? `${(100 - safeAnalytics.failRate).toFixed(1)}%`
        : '—',
      icon: 'ri-percent-line',
      color: 'bg-amber-100 text-amber-600',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
      {stats.map((stat) => (
        <div
          key={stat.label}
          className="bg-white rounded-xl shadow-sm p-5 hover:shadow-md transition-all"
        >
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs text-gray-500 font-medium">{stat.label}</span>
            <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${stat.color}`}>
              <i className={`${stat.icon} text-lg`}></i>
            </div>
          </div>
          <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
        </div>
      ))}
    </div>
  );
}
